import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { Field, TextInput, Segmented, ProvinceInput, Check } from "@/components/form/fields";
import { CopyLinkButton } from "@/components/landing/SpeakersForWho";

const YN = [{ value: "si", label: "Sì" }, { value: "no", label: "No" }];
const Note = ({ children }) => <p className="text-[13px] leading-relaxed text-sand">{children}</p>;

export const StepContact = ({ d, set, e }) => (
  <div className="space-y-5">
    <Field label="Nome e cognome" id="nome" error={e.nome}>
      <TextInput id="nome" value={d.nome} onChange={(v) => set({ nome: v })} error={e.nome} autoComplete="name" placeholder="Es. Laura Bianchi" />
    </Field>
    <Field label="WhatsApp" id="whatsapp" error={e.whatsapp}>
      <TextInput id="whatsapp" value={d.whatsapp} onChange={(v) => set({ whatsapp: v })} error={e.whatsapp} inputMode="tel" autoComplete="tel" />
    </Field>
    <Note>Usa il tuo numero vero: il link Zoom arriva solo qui, dopo la verifica dell'iscrizione.</Note>
    <Note>
      Cliccando "Avanti" accetti di essere ricontattata per completare l'iscrizione.{" "}
      <Link to="/privacy" target="_blank" className="text-gold-light underline underline-offset-4" data-testid="form-privacy-link">Informativa privacy</Link>
    </Note>
  </div>
);

export const StepCenter = ({ d, set, e }) => (
  <div className="space-y-5">
    <Field label="Sei la titolare del centro?" id="titolare" error={d.titolare === "no" ? null : e.titolare}>
      <Segmented id="titolare" value={d.titolare} onChange={(v) => set({ titolare: v })} options={[{ value: "si", label: "Sì, sono la titolare" }, { value: "no", label: "No" }]} />
    </Field>
    {d.titolare === "no" ? (
      <div className="rounded-2xl border border-gold/40 bg-gold/[0.07] p-6" data-testid="not-owner-message">
        <p className="text-[15px] leading-relaxed text-cream">
          <b className="text-gold-light">Il workshop è riservato alle titolari.</b> Copia il link e giralo alla tua titolare: si iscrive lei e, se vuole, ti porta con sé davanti allo schermo.
        </p>
        <div className="mt-5"><CopyLinkButton testid="form-copy-link-btn" /></div>
      </div>
    ) : (
      <>
        <Field label="Nome del centro" id="nome_centro" error={e.nome_centro}>
          <TextInput id="nome_centro" value={d.nome_centro} onChange={(v) => set({ nome_centro: v })} error={e.nome_centro} placeholder="Es. Centro Estetico Laura" />
        </Field>
        <div className="grid gap-5 sm:grid-cols-2">
          <Field label="Città" id="citta" error={e.citta}>
            <TextInput id="citta" value={d.citta} onChange={(v) => set({ citta: v })} error={e.citta} autoComplete="address-level2" />
          </Field>
          <Field label="Provincia" id="provincia" error={e.provincia}>
            <ProvinceInput value={d.provincia} error={e.provincia} onType={(v) => set({ provincia: v })} onPick={(p) => set({ provincia: p.nome, regione: p.regione })} />
          </Field>
        </div>
        <Field label="Regione" id="regione" error={e.regione}>
          <TextInput id="regione" value={d.regione} onChange={(v) => set({ regione: v })} error={e.regione} placeholder="Si compila dalla provincia" />
        </Field>
        <Field label="Quante cabine?" id="cabine" error={e.cabine}>
          <Segmented id="cabine" value={d.cabine} onChange={(v) => set({ cabine: v })} options={[{ value: "1", label: "1" }, { value: "2-3", label: "2-3" }, { value: "4+", label: "4 o più" }]} />
        </Field>
        <Field label="Usi già prodotti Skin Lovers?" id="cliente_skinlovers" error={e.cliente_skinlovers}>
          <Segmented id="cliente_skinlovers" value={d.cliente_skinlovers} onChange={(v) => set({ cliente_skinlovers: v })} options={YN} />
        </Field>
      </>
    )}
  </div>
);

export const StepInvoice = ({ d, set, e }) => (
  <div className="space-y-5">
    <p className="eyebrow">Dati per la fattura</p>
    <Field label="Ragione sociale" id="ragione_sociale" error={e.ragione_sociale}>
      <TextInput id="ragione_sociale" value={d.ragione_sociale} onChange={(v) => set({ ragione_sociale: v })} error={e.ragione_sociale} autoComplete="organization" />
    </Field>
    <div className="grid gap-5 sm:grid-cols-2">
      <Field label="Partita IVA" id="partita_iva" error={e.partita_iva}>
        <TextInput id="partita_iva" value={d.partita_iva} onChange={(v) => set({ partita_iva: v.replace(/[^\d]/g, "").slice(0, 11) })} error={e.partita_iva} inputMode="numeric" placeholder="11 cifre" />
      </Field>
      <Field label="Codice SDI o PEC" id="sdi_pec" error={e.sdi_pec}>
        <TextInput id="sdi_pec" value={d.sdi_pec} onChange={(v) => set({ sdi_pec: v })} error={e.sdi_pec} />
      </Field>
    </div>
    <Field label="Email" id="email" error={e.email}>
      <TextInput id="email" type="email" value={d.email} onChange={(v) => set({ email: v })} error={e.email} autoComplete="email" />
    </Field>
    <Check id="consenso_privacy" checked={d.consenso_privacy} onChange={(v) => set({ consenso_privacy: v })} error={e.consenso_privacy}>
      Ho letto l'<Link to="/privacy" target="_blank" className="text-gold-light underline underline-offset-4">informativa privacy</Link> e accetto di ricevere i promemoria del workshop
    </Check>
    <Note>Inserisci dati veri: verifichiamo ogni iscrizione e il link Zoom arriva solo alle titolari con dati completi e corretti.</Note>
    <Check id="consenso_marketing" checked={d.consenso_marketing} onChange={(v) => set({ consenso_marketing: v })}>
      Voglio ricevere novità e offerte Skin Lovers <span className="text-sand">(facoltativo)</span>
    </Check>
  </div>
);

const ROWS = [["Workshop Natural Anti-Age · 2 serate", "€27,00"], ["Replay 30 giorni + PDF Super Glow", "inclusi"], ["IVA 22%", "€5,94"]];

export const StepPayment = () => (
  <div className="space-y-5">
    <p className="eyebrow">Pagamento</p>
    <div className="rounded-2xl border border-line bg-ink/60 p-5" data-testid="payment-summary">
      {ROWS.map(([a, b]) => (
        <div key={a} className="flex justify-between gap-4 border-b border-line py-3 text-sm text-sand"><span>{a}</span><span className="text-cream">{b}</span></div>
      ))}
      <div className="flex items-baseline justify-between pt-4">
        <span className="font-semibold uppercase tracking-[0.14em] text-cream">Totale</span>
        <span className="font-serif text-4xl font-semibold text-gold-light" data-testid="payment-total">€32,94</span>
      </div>
    </div>
    <p className="flex items-start gap-2 text-[13px] leading-relaxed text-sand">
      <Lock className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
      Pagamento sicuro con carta tramite Stripe: si apre la pagina protetta di pagamento e poi torni qui. Ricevi la fattura via email.
    </p>
  </div>
);
